import React, { useCallback, useReducer, useEffect } from 'react'

const SearchState = {
  results: [],
  status: 'idle',
  search: () => {},
  searchTerms: '',
}

const Context = React.createContext(SearchState)

const matches = (str1, str2) => {
  return (
    typeof str1 === 'string' &&
    typeof str2 === 'string' &&
    str1.toLocaleLowerCase().indexOf(str2.toLocaleLowerCase()) !== -1
  )
}

const CreateSearchProvider =
  (searchFn) =>
  ({ children }) => {
    const [state, dispatch] = useReducer((state, action) => {
      switch (action.type) {
        case 'search::start':
          return { ...state, status: 'loading', searchTerms: action.payload }
        case 'search::finish':
          return { ...state, status: 'idle', results: action.payload }
        default:
          return state
      }
    }, SearchState)

    const search = useCallback((searchTerms) => {
      dispatch({ type: 'search::start', payload: searchTerms })
      ;(async () => {
        let results = []
        try {
          results = await searchFn(searchTerms)
        } finally {
          dispatch({ type: 'search::finish', payload: results })
        }
      })()
    }, mockData)

    useEffect(() => {
      if (window.location.pathname === '/search-results/') {
        const urlSearchParams = new URLSearchParams(window.location.search)
        const params = Object.fromEntries(urlSearchParams.entries())
        search(params.q)
      }
    }, [])

    return (
      <Context.Provider value={{ ...state, search }}>
        {children}
      </Context.Provider>
    )
  }

const mockData = []

const MockupProvider = CreateSearchProvider(
  (searchTerms) =>
    new Promise((resolve) => {
      const results = []
      for (let record of mockData) {
        if (
          Object.values(record).find((value) => matches(value, searchTerms))
        ) {
          results.push(record)
        }
      }
      setTimeout(() => {
        resolve(results)
      }, 1000)
    })
)

const GoogleProvider = CreateSearchProvider(async (searchTerms) => {
  const quotaUser = Math.random()

  if (!searchTerms) {
    return []
  }

  return (
    (
      await (
        await fetch(
          `https://www.googleapis.com/customsearch/v1/siterestrict?key=${process.env.GATSBY_GOOGLE_SEARCH_KEY}&cx=${process.env.GATSBY_GOOGLE_SEARCH_CX}&q=${searchTerms}&quotaUser=${quotaUser}`
        )
      ).json()
    ).items || []
  )
})

const SearchContext = {
  Context,
  MockupProvider,
  GoogleProvider,
}

export default SearchContext
